<nav
  class="mobile-header"
  [ngClass]="{ 'nav-points-header': isPointsNavShown$ | async }">
  <div class="header-container">
    <button
      class="nav-toggle focus-link"
      aria-label="Toggle menu here"
      (click)="openSideNav()"
      [attr.aria-hidden]="isSideNavOpen">
      <span class="hamburger-menu-bar">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>
    <span class="header-branding">
      <a
        [routerLink]="['/']"
        [attr.aria-hidden]="isSideNavOpen"
        class="focus-link">
        <img alt="ANZ logo" class="header-logo" [src]="logoImageUrl" />
      </a>
    </span>
    <div class="title">{{ 'wl.anz.header.title' | translate }}</div>
    <rd-sc-header-icon
      *ngIf="
        featureFlagService.isEnable(shoppingCartFeatureFlag) &&
        (isLoggedIn$ | async)
      "
      class="ml-auto mr-0"
      [itemCount]="cartItemFacade.cartItemsTotalLineItems$ | async"
      [dataTestid]="'anz-header-button-cart'"></rd-sc-header-icon>
  </div>

  <div
    *ngIf="isLoggedIn$ | async"
    class="nav-points-bar points-summary relative">
    <ng-container
      *ngIf="pointsSummaryFacade.pointsSummary$ | async as pointsSummary">
      <ng-container *ngIf="activePointsAccount$ | async">
        <p class="flex items-center">
          <strong *ngIf="loyaltyCurrency$ | async as loyaltyCurrency">
            {{ pointsSummary.pointsBalance | localizePointsNumber: '1.0-0' }}
            {{ loyaltyCurrency.name }}
          </strong>

          <ng-container *ngIf="expiryPoints$ | async as expiryPoints">
            <ng-container
              *ngIf="
                'wl.anz.header.tooltips'
                  | translate
                    : {
                        expiryPoints: expiryPoints,
                        loyaltyCurrency: (loyaltyCurrency$ | async).name,
                        expiryDate: lastDayInYear
                      } as tooltipsContent
              ">
              <button
                #expiryPointsButton
                class="focus-link ml-2 h-4 max-h-full w-4 max-w-full border-none bg-transparent p-0 hover:cursor-pointer"
                (click)="showExpiryPointsTooltip()"
                [attr.aria-label]="tooltipsContent">
                <rd-shared-icon
                  iconSymbol="icon-warning-solid"></rd-shared-icon>
              </button>

              <rd-anz-tooltips
                #expiryPointsTooltips
                [attr.aria-label]="
                  'wl.anz.header.accessibility.expiry_points_tooltips'
                    | translate
                "
                (visibilityChanged)="onTooltipsVisibilityChanged()">
                <span class="mr-2"> {{ tooltipsContent }} </span>
              </rd-anz-tooltips>
            </ng-container>
          </ng-container>
        </p>
      </ng-container>
    </ng-container>
  </div>

  <mat-sidenav-container class="sidenav-container" [ngStyle]="style()">
    <mat-sidenav
      #sidenav
      position="start"
      mode="over"
      class="sidenav"
      (closedStart)="handleSideNavClose()"
      (openedStart)="handleSideNavOpen()"
      (openedChange)="handleSideNavOpenChange()">
      <rd-anz-side-nav-content
        (sideNavClose)="closeSideNav()"
        (userAction)="handleUserAction($event)"
        [sideNavOpen]="sideNavOpenEvent.asObservable()"
        [isSideNavOpen]="isSideNavOpen"
        [cardSelectorDisabled]="cardSelectorDisabled">
      </rd-anz-side-nav-content>
    </mat-sidenav>
  </mat-sidenav-container>
</nav>
